import { toast } from "react-toastify";
import { VARIABLES_API } from "../views/MainLayout/components/shared/services/variables";
import { makeSetReducer } from "./utils";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

export const variablesFullfilledReducer = makeSetReducer(['variables/fullfilled']);

export const fetchVariables = () => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await VARIABLES_API.get()
        const data = await response.data;
        dispatch({ type: 'variables/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}